import { ApiResponse, Question } from '../models';
import * as http from './http';
import ApiService from './service';

export class NeedProfileManagementService extends ApiService {
  public async loadAllQuestions(): Promise<Question[]> {
    const url = `${this.apiDomain}/api/questionaire`;

    const resposne = await http.get<ApiResponse<Question[]>>(url, this.store);
    return resposne?.data?.data;
  }

  public async createQuestion(data: Question): Promise<Question> {
    const url = `${this.apiDomain}/api/questionaire/question`;

    const response = await http.post<ApiResponse<Question>>(
      url,
      data,
      this.store
    );

    return response.data?.data;
  }

  public async updateQuestion(id: string, data: Question): Promise<Question> {
    const url = `${this.apiDomain}/api/questionaire/question/${id}`;

    const response = await http.put<ApiResponse<Question>>(
      url,
      data,
      this.store
    );
    return response.data?.data;
  }

  public async deleteQuestion(id?: string) {
    const url = `${this.apiDomain}/api/questionaire/question/${id}`;

    const response = await http.remove<ApiResponse<Question>>(url, this.store);
    return response.data;
  }
}
